<template>
  <div class="vzan-address">
    <van-popup
      class="vzan-address-popup"
      id="vzanAddressPopup"
      :value="$attrs.show"
      round
      position="bottom"
      @click-overlay="handleClose"
      v-loading="loading"
    >
      <div class="vzan-address-header" id="vzanAddressHeader">
        <span>选择收货地址</span>
        <img
          class="close-button"
          src="../vzan-address-editor/img/close.png"
          alt=""
          @click="handleClose"
        />
      </div>
      <div class="vzan-address-container">
        <van-radio-group v-model="selected">
          <div class="vzan-address-item" v-for="item in list" :key="item.id">
            <van-radio
              :name="item.id"
              class="item-radio"
              :checked-color="color"
            >
              <div class="vzan-address-item-content">
                <div class="main-info">
                  <div class="name">{{ item.userName }}</div>
                  <div class="phone">{{ item.telNumber }}</div>
                </div>
                <div class="sub-info">{{ item | getAddressDetail }}</div>
              </div>
              <div class="item-action" :style="{ color }" @click.stop>
                <img
                  class="edit-icon"
                  src="./img/edit.png"
                  alt=""
                  @click="editAddress(item.id)"
                />
              </div>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
      <div class="vzan-address-footer" id="vzanAddressFooter">
        <van-button
          :class="['address-button', ...subButtonClass]"
          round
          light
          @click="editAddress(0)"
          >{{ subButtonText }}</van-button
        >
        <van-button
          :class="['address-button', ...mainButtonClass]"
          round
          @click="handleSave"
          >{{ mainButtonText }}</van-button
        >
      </div>
    </van-popup>

    <vzanAddressEditor
      v-model="editor_showing"
      :addressId="editing"
      :color="color"
      :subButtonClass="subButtonClass"
      :mainButtonClass="mainButtonClass"
      @close="init"
    />
  </div>
</template>

<script>
import vzanAddressEditor from '../vzan-address-editor'
import $api from './api'
export default {
  name: 'VzanAddress',
  components: {
    vzanAddressEditor,
  },
  model: {
    prop: 'show',
    event: 'show',
  },
  props: {
    color: {
      // 主题色
      type: String,
      default: '#f40000',
    },
    subButtonClass: {
      // 副按钮样式名
      type: Array,
      default() {
        return ['address-button-sub']
      },
    },
    subButtonText: {
      // 副按钮文本
      type: String,
      default: '新增地址',
    },
    mainButtonClass: {
      // 主按钮样式名
      type: Array,
      default() {
        return ['address-button-main']
      },
    },
    mainButtonText: {
      // 主按钮文本
      type: String,
      default: '确定',
    },
    validDetailInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      editor_showing: false,
      scrollview_height: undefined,
      list: [],
      selected: undefined,
      editing: undefined,
    }
  },
  watch: {
    '$attrs.show': {
      handler(show) {
        show && this.init()
      },
    },
  },
  filters: {
    getAddressDetail(item) {
      const { cityName, detailInfo, provinceName, townName } = item
      return provinceName + cityName + townName + detailInfo
    },
  },
  methods: {
    async init() {
      this.getScrollViewHeight()
      await this.address()
      this.list.length ? this.default_address() : (this.selected = 0)
      this.$forceUpdate()
    },
    async getScrollViewHeight() {
      await this.$nextTick()
      const popup = document.getElementById('vzanAddressPopup')
      const header = document.getElementById('vzanAddressHeader')
      const footer = document.getElementById('vzanAddressFooter')
      const popup_height = popup ? popup.getClientRects()[0]['height'] : 0
      const header_height = header ? header.getClientRects()[0]['height'] : 0
      const footer_height = footer ? footer.getClientRects()[0]['height'] : 0
      this.scrollview_height = popup_height - header_height - footer_height
    },
    async address() {
      try {
        this.loading = true
        const res = await $api.address({})
        this.list = res.dataObj || []
      } catch (error) {
        this.$toast(typeof error === 'string' ? error : '获取地址异常')
      } finally {
        this.loading = false
      }
    },
    async default_address() {
      try {
        const res = await $api.default_address({})
        this.selected = res.dataObj && res.dataObj.id
      } catch (error) {
        console.log(error)
      }
    },
    editAddress(id) {
      this.editing = id
      this.editor_showing = true
    },
    handleClose() {
      this.$emit('show', false)
    },
    handleSave() {
      if (!this.selected && !this.list.length) {
        return this.editAddress(0)
      }
      if (this.validDetailInfo) {
        const { provinceName, cityName, townName, detailInfo } = this.list.find(
          i => i.id === this.selected
        )
        if (
          [provinceName, cityName, townName, detailInfo].some(item => !item)
        ) {
          this.$toast('请填写详细地址')
          this.editAddress(this.selected)
          return
        }
      }
      this.$emit('ok', this.selected)
      this.handleClose()
    },
  },
}
</script>

<style scoped lang="scss">
.vzan-address-popup {
  background: #f5f7fa;
  height: 60%;
}
.vzan-address-header {
  box-sizing: border-box;
  padding: 16px 0;
  font-size: var(--set-font-size16);
  font-weight: 500;
  color: #202124;
  line-height: 23px;
  text-align: center;
  background: #ffffff;
  position: relative;
  .close-button {
    position: absolute;
    top: 50%;
    right: 12px;
    font-size: var(--set-font-size20);
    transform: translateY(-50%);
    color: #dddfe5;
    width: 23px;
    height: 23px;
    &:active {
      opacity: 0.5;
    }
  }
}
.vzan-address-container {
  position: relative;
  padding: 0 8px 12px;
  box-sizing: border-box;
  height: calc(100% - (128px + env(safe-area-inset-bottom)));
  margin-top: 12px;
  overflow: hidden auto;
}
.vzan-address-item {
  box-sizing: border-box;
  padding: 16px 12px;
  background: #ffffff;
  border-radius: 8px;
  &:not(:last-of-type) {
    margin-bottom: 12px;
  }
  ::v-deep .item-radio {
    padding-right: 14px;
    .van-radio__label {
      display: flex;
      align-items: center;
    }
  }
  .main-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: var(--set-font-size16);
    font-weight: 500;
    color: #202124;
    line-height: 23px;
    margin-bottom: 4px;
    .name {
      margin-right: 8px;
    }
  }
  .sub-info {
    font-size: var(--set-font-size13);
    font-weight: 400;
    color: #60646b;
    line-height: 20px;
  }
  .vzan-address-item-content {
    flex: 1;
  }
  .item-action {
    font-size: var(--set-font-size22);
    color: #c4c6ca;
    font-weight: bold;
    margin-left: 30px;
    flex-shrink: 0;
    .edit-icon {
      width: 22px;
      height: 22px;
      &:active {
        opacity: 0.5;
      }
    }
  }
}
.vzan-address-footer {
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 12px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.address-button {
  flex: 1;
  border: 0;
  font-size: var(--set-font-size14);
  &:not(:last-of-type) {
    margin-right: 12px;
  }
}
.address-button-main {
  background: #f40000;
  color: #ffffff;
}
.address-button-sub {
  background: #fff1f0;
  color: #f40000;
}
</style>
